import React, { useEffect } from "react";
import { useState } from "react";

function FinalTotals({ totalLATH, totalMVIS, sqFeet }) {
	let savingsMsg = "Your Savings with MVIS";
	let totalSav = parseFloat(totalLATH.total - totalMVIS.total);
	let percentSav =
		((totalLATH.total - totalMVIS.total) / totalLATH.total) * 100;

	if (totalLATH.total < totalMVIS.total) {
		totalSav = 0;
		percentSav = (totalMVIS.total - totalLATH.total) / totalMVIS.total;
	}
	let totalSavSq = totalSav * sqFeet;

	return (
		<div id="total-savings">
			<div className="row content" id="savings-message">
				<h3>{savingsMsg}</h3>
			</div>
			<div id="total-savings-ribbon">
				<div className="content">
					<div className="row">
						<div className="col-md-3  ">
							<p>Cost Difference/ft²</p>
							<h3 className="blue">${totalSav.toFixed(2)} </h3>
						</div>
						<div className="col-md-3  ">
							<p>Total Cost Difference</p>
							<h3 className="green">${totalSavSq.toFixed(2)}</h3>
						</div>
						<div className="col-md-3  ">
							<p>Percent Savings</p>
							<h3 className="blue">{percentSav.toFixed(0)}%</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
export default FinalTotals;
